import { render, staticRenderFns } from "./ta_project_details1.vue?vue&type=template&id=1a861f22&scoped=true&"
import script from "./ta_project_details1.vue?vue&type=script&lang=js&"
export * from "./ta_project_details1.vue?vue&type=script&lang=js&"
import style0 from "./ta_project_details1.vue?vue&type=style&index=0&id=1a861f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a861f22",
  null
  
)

export default component.exports